module.exports = __webpack_public_path__ + "img/returnSkuPutawayStorerkey.2853a02d.png";